enum TaxiListingFilterType {
  TAX_NUMBER = "TAX_NUMBER",
  COMPANY_ID = "COMPANY_ID",
  NATIONAL_COURT_REGISTER = "NATIONAL_COURT_REGISTER",
  NAME = "NAME",
  DISPLAY_NAME = "DISPLAY_NAME",
  ADDRESS = "ADDRESS",
  NOTES = "NOTES",
}

export default TaxiListingFilterType;
